(function () {
  const COOKIE_NAME = 'age18_confirmed';

  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const cookieString = `; ${document.cookie}`;
    const parts = cookieString.split(`; ${encodeURIComponent(name)}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function deleteCookie(name) {
    document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  }

  /* ------------------------------------------------------------------ */
  /*  Sync all age-check checkboxes & checkout buttons on the page      */
  /* ------------------------------------------------------------------ */
  function syncAllCheckboxes(checked) {
    document.querySelectorAll('.js-age-check-checkbox').forEach(el => {
      el.checked = checked;
      const container = el.closest('.cart-age-check, .power-step-age-check');
      if (container) {
        container.classList.toggle('cart-age-check--confirmed', checked && container.classList.contains('cart-age-check'));
        container.classList.toggle('power-step-age-check--confirmed', checked && container.classList.contains('power-step-age-check'));
      }
    });
    document.querySelectorAll('.js-checkout-btn[data-age-check-required]').forEach(btn => {
      btn.disabled = !checked;
    });

    // Also sync power-step button (uses different mechanism)
    const psBtn = document.querySelector('.power-step-modal__footer .js-checkout-button');
    if (psBtn) {
      if (checked) {
        psBtn.classList.remove('btn--disabled');
        psBtn.style.pointerEvents = '';
        psBtn.style.opacity = '';
      } else {
        psBtn.classList.add('btn--disabled');
        psBtn.style.pointerEvents = 'none';
        psBtn.style.opacity = '0.5';
      }
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Event delegation: survives DOM re-renders (cart drawer innerHTML)  */
  /* ------------------------------------------------------------------ */
  function initAgeCheckDelegation() {
    // Set initial state from cookie
    const alreadyConfirmed = getCookie(COOKIE_NAME) === 'true';
    if (alreadyConfirmed) {
      syncAllCheckboxes(true);
    }

    // Delegated change listener for ALL age-check checkboxes
    document.body.addEventListener('change', (evt) => {
      const cb = evt.target.closest('.js-age-check-checkbox');
      if (!cb) return;

      if (cb.checked) {
        setCookie(COOKIE_NAME, 'true', 30);
        syncAllCheckboxes(true);
      } else {
        deleteCookie(COOKIE_NAME);
        syncAllCheckboxes(false);
      }
    });

    // Power step modal observer: sync state when modal opens
    const modal = document.querySelector('power-step-modal');
    if (modal) {
      const observer = new MutationObserver(() => {
        if (modal.getAttribute('aria-hidden') === 'true') return;

        const hasAgeProduct = !!document.getElementById('cart-age-check');
        const psAgeCheck = document.getElementById('power-step-age-check');
        const psCheckbox = document.getElementById('power-step-age-check-confirm');

        if (!psAgeCheck) return;

        if (hasAgeProduct) {
          psAgeCheck.style.display = '';
          const confirmed = getCookie(COOKIE_NAME) === 'true';
          if (psCheckbox) psCheckbox.checked = confirmed;
          psAgeCheck.classList.toggle('power-step-age-check--confirmed', confirmed);
          syncAllCheckboxes(confirmed);
        } else {
          psAgeCheck.style.display = 'none';
          syncAllCheckboxes(true);
        }
      });
      observer.observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    // Re-apply state after cart drawer re-renders its sections
    document.addEventListener('on:line-item:change', () => {
      const confirmed = getCookie(COOKIE_NAME) === 'true';
      // Allow DOM to settle after innerHTML replacement
      requestAnimationFrame(() => syncAllCheckboxes(confirmed));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeCheckDelegation);
  } else {
    initAgeCheckDelegation();
  }
})();
